import Conversion from './Conversion';

export default class TipoNota {
  constructor(data) {
    Object.assign(this, data);
    this.conversiones = (this.conversiones || []).map((conversion) => {
      conversion.tipo_nota = new TipoNota(conversion.tipo_nota);
      conversion.tipo_nota_resultado = new TipoNota(conversion.tipo_nota_resultado);
      return new Conversion(conversion);
    });
  }

  // Puede seleccionar si es de tipo texto y es un selector (tiene opciones)
  get puedeSeleccionarTipoVisualizacion() {
    // Lo deshabilitamos temporalmente hasta que solucionemos bien el
    // redimensionado de las columnas del cuaderno
    // return this.tipo_nota === 'texto' && this.selector;
    return false;
  }

  nombreParaValor(valor) {
    const opcion = (this.opciones || []).find((op) => op.valor === valor);
    return opcion ? opcion.nombre : null;
  }
}
